var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "600" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("manage-labels")))]),
          _c(
            "w-card-content",
            [
              !_vm.rows.length
                ? _c("div", { staticClass: "no-labels" }, [
                    _vm._v(_vm._s(_vm.$ct("no-labels"))),
                  ])
                : _c(
                    "div",
                    { staticClass: "labels-list" },
                    _vm._l(_vm.rows, function (row) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.edit"),
                              expression: "$ct('common.edit')",
                            },
                          ],
                          key: row.ID,
                          staticClass: "label-chip",
                          class: { active: _vm.editingId === row.ID },
                          style: {
                            backgroundColor: row.Color,
                            color: _vm.textColor(row.Color),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.startEdit(row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(row.Name))]
                      )
                    }),
                    0
                  ),
              _vm.editingRow
                ? _c(
                    "w-row",
                    { staticClass: "label-row edit-panel mt" },
                    [
                      _c("app-color-picker", {
                        attrs: {
                          color: _vm.editingRow.Color,
                          compact: "",
                          fancy: "",
                          label: _vm.$ct("label-color"),
                        },
                        on: {
                          input: function ($event) {
                            _vm.editingRow.Color = $event
                          },
                        },
                      }),
                      _c("w-input", {
                        staticClass: "name-input",
                        attrs: {
                          fancy: "",
                          autofocus: "",
                          label: _vm.$ct("label-name"),
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.saveRow(_vm.editingRow)
                          },
                        },
                        model: {
                          value: _vm.editingRow.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.editingRow, "Name", $$v)
                          },
                          expression: "editingRow.Name",
                        },
                      }),
                      _c("w-button", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.save"),
                            expression: "$ct('common.save')",
                          },
                        ],
                        attrs: {
                          flat: "",
                          icon: "save",
                          disabled: _vm.busy || !_vm.editingRow.Name.trim(),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.saveRow(_vm.editingRow)
                          },
                        },
                      }),
                      _c("w-button", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        attrs: { flat: "", icon: "trash", disabled: _vm.busy },
                        on: {
                          click: function ($event) {
                            return _vm.deleteRow(_vm.editingRow)
                          },
                        },
                      }),
                      _c("w-button", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.cancel"),
                            expression: "$ct('common.cancel')",
                          },
                        ],
                        attrs: { flat: "", icon: "times", disabled: _vm.busy },
                        on: {
                          click: function ($event) {
                            return _vm.cancelEdit(_vm.editingRow)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("w-divider"),
              _c(
                "w-row",
                { staticClass: "label-row mt" },
                [
                  _c("app-color-picker", {
                    attrs: {
                      color: _vm.newLabel.Color,
                      compact: "",
                      fancy: "",
                      label: _vm.$ct("label-color"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.newLabel.Color = $event
                      },
                    },
                  }),
                  _c("w-input", {
                    staticClass: "name-input",
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("label-name"),
                      autofocus: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.addLabel()
                      },
                    },
                    model: {
                      value: _vm.newLabel.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.newLabel, "Name", $$v)
                      },
                      expression: "newLabel.Name",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      attrs: {
                        icon: "plus",
                        disabled: _vm.busy || !_vm.newLabel.Name.trim(),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addLabel()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("common.add")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "times", disabled: _vm.busy },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }